import React from "react";
import {Component} from 'react'
import {auth, dbase} from "../../../firebase/index";
import {HOME} from "../../../constants/routes";
import {byPropKey} from "../../utils";
import {withRouter} from "react-router-dom";
import {ForgotPasswordLink} from "../forgotpassword/ForgotPasswordLink";
import {ERROR_FORM_VALIDATION} from "../../../constants/messages";
import {urlLogo} from "../../../constants/asseturls";
import './styles.css';

/**
 * Initial/ fallback state
 */
const INITIAL_STATE = {
    username: '',
    email: '',
    password: '',
    error: null,
};

/**
 * Form component of the Sign In page.
 * Should be rendered such that this component can shared around different pages.
 */
class SignInForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...INITIAL_STATE
        };
    }

    /**
     * Called when the form is submitted.
     * Executes a user sign in on firebase or handles an error if failed.
     */
    onSubmit = (event) => {
        // Validate form fields on backend - NEVER trust data from user
        if (this.isInvalid()) {
            this.setState(byPropKey('error', new Error(ERROR_FORM_VALIDATION)));

        } else {
            // 1. Set the authentication persistence mode to session.
            //      i.e. will be signed out if the window/tab is closed.
            auth.doSetAuthSessionPersistence()
                .then(() => {
                    // 2. Attempt sign in using firebase API
                    auth.doSignInWithEmailAndPassword(this.state.email, this.state.password)
                        .then(() => {
                            // 3. Create user extension for main database table (if it doesn't exist already)
                            dbase.doCreateUser(auth.getCurrentUserUid(), this.state.email);

                            // 4. Reset state
                            this.setState(() => ({
                                ...INITIAL_STATE
                            }));

                            // 5. Redirect to homepage
                            this.props.history.push(HOME);
                        })
                        .catch(error => {
                            this.setState(byPropKey('error', error));
                        });
                })
                .catch(error => {
                    this.setState(byPropKey('error', error));
                });
        }

        // Prevents the default reload of a browser which would otherwise be natural behaviour when submitting a form.
        event.preventDefault();
    };

    /**
     * @returns {boolean} {@code true} if the current state variables
     * are invalid and should not be logged in.
     */
    isInvalid = () => {
        const isPasswordEmpty = this.state.passwordOne === '';
        const isEmailEmpty = this.state.email === '';
        return isPasswordEmpty || isEmailEmpty;
    };

    render() {
        const isInvalid = this.isInvalid();

        return (
            <section className="login-form">
                <form onSubmit={this.onSubmit}>
                    <img src={urlLogo} className="img-responsive" alt="AutoI" />
                    <input
                        id="txtEmail"
                        className="form-control input-lg"
                        value={this.state.email}
                        onChange={event => this.setState(byPropKey('email', event.target.value))}
                        type="email"
                        placeholder="Your Email"
                        required
                    />

                    <input
                        id="txtPw"
                        className="form-control input-lg"
                        value={this.state.password}
                        onChange={event => this.setState(byPropKey('password', event.target.value))}
                        type="password"
                        placeholder="Your Password"
                        required
                    />

                    <button
                        className="btn btn-lg btn-primary btn-block"
                        disabled={isInvalid}
                        type="submit"
                    >
                        Sign In
                    </button>

                    {
                        // Show error message when state.error exists
                        this.state.error &&
                        <p className="error">
                            {this.state.error.message}
                        </p>
                    }
                    <ForgotPasswordLink />
                </form>
            </section>
        );
    }
}

export default withRouter(SignInForm);



// WEBPACK FOOTER //
// ./src/components/auth/signin/SignInForm.jsx